// Project / work domains a posting can be tagged with. Shared by every job form.
export const PROJECT_DOMAINS = [
  'Web Development', 'Mobile App Development', 'Full Stack Development',
  'Frontend Development', 'Backend Development',
  'Artificial Intelligence', 'Machine Learning', 'Deep Learning',
  'Data Science', 'Data Analytics', 'Business Analytics', 'Data Engineering',
  'Cloud Computing', 'DevOps', 'Site Reliability Engineering',
  'Cybersecurity', 'Blockchain', 'Internet of Things (IoT)', 'Embedded Systems',
  'Robotics', 'Automation', 'Game Development', 'AR / VR',
  'UI / UX Design', 'Graphic Design', 'Product Management', 'Project Management',
  'Software Testing / QA', 'Database Management', 'Networking',
  'ERP / SAP', 'CRM / Salesforce', 'E-commerce', 'FinTech', 'HealthTech', 'EdTech',
  'Digital Marketing', 'Content & Media', 'Sales & Business Development',
  'Finance & Accounting', 'Human Resources', 'Operations & Supply Chain',
  'Research & Development', 'Core Mechanical Engineering', 'Civil / Construction',
  'Electrical & Electronics', 'Chemical / Process Engineering',
  'Aerospace', 'Automotive', 'Biotechnology', 'Pharmaceutical',
  'Consulting', 'Banking & Insurance', 'Legal & Compliance', 'Teaching & Training'
];
